"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Expand_exports = {};
__export(Expand_exports, {
  default: () => Expand_default
});
module.exports = __toCommonJS(Expand_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.4922 3.33594C12.4922 3.19271 12.5378 3.07552 12.6289 2.98438C12.7331 2.88021 12.8568 2.82812 13 2.82812H17.3359C17.4922 2.82812 17.6289 2.88672 17.7461 3.00391C17.8633 3.12109 17.9219 3.25781 17.9219 3.41406V7.75C17.9219 7.89323 17.8698 8.01693 17.7656 8.12109C17.6745 8.21224 17.5573 8.25781 17.4141 8.25781C17.2839 8.25781 17.1667 8.21224 17.0625 8.12109C16.9714 8.01693 16.9258 7.89323 16.9258 7.75V4.54688L12.5117 8.94141C12.4206 9.03255 12.3034 9.07812 12.1602 9.07812C12.0299 9.07812 11.9128 9.03255 11.8086 8.94141C11.7174 8.83724 11.6719 8.72005 11.6719 8.58984C11.6719 8.44661 11.7174 8.32943 11.8086 8.23828L16.2031 3.82422H13C12.8568 3.82422 12.7331 3.77865 12.6289 3.6875C12.5378 3.58333 12.4922 3.46615 12.4922 3.33594ZM4.07422 12.75V15.9531L8.48828 11.5586C8.57943 11.4674 8.6901 11.4219 8.82031 11.4219C8.96354 11.4219 9.08724 11.4674 9.19141 11.5586C9.28255 11.6628 9.32812 11.7865 9.32812 11.9297C9.32812 12.0599 9.28255 12.1706 9.19141 12.2617L4.79688 16.6758H8C8.14323 16.6758 8.26042 16.7279 8.35156 16.832C8.45573 16.9232 8.50781 17.0339 8.50781 17.1641C8.50781 17.3073 8.45573 17.431 8.35156 17.5352C8.26042 17.6263 8.14323 17.6719 8 17.6719H3.66406C3.50781 17.6719 3.37109 17.6133 3.25391 17.4961C3.13672 17.3789 3.07812 17.2422 3.07812 17.0859V12.75C3.07812 12.6068 3.1237 12.4896 3.21484 12.3984C3.31901 12.2943 3.44271 12.2422 3.58594 12.2422C3.71615 12.2422 3.82682 12.2943 3.91797 12.3984C4.02214 12.4896 4.07422 12.6068 4.07422 12.75Z",
      fill: "currentColor"
    }
  )
);
const SvgExpand = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Expand_default = SvgExpand;
